import type { RuleDefinition } from '../ruleRegistry';

export const ELECTRICAL_RULES = [
    {
        id: 'electrical.hotZoneThresholdMm',
        category: 'electrical',
        label: 'Varm zon tröskel',
        description: 'Höjd i mm ovanför golvet där silikonkabel krävs. Komponenter ovanför denna gräns kräver SiHF-kabel.',
        defaultValue: 500,
        valueType: 'number',
        unit: 'mm',
        source: 'SEK Svensk Elstandard',
        dangerLevel: 'critical',
    },
    {
        id: 'electrical.siliconeCableType',
        category: 'electrical',
        label: 'Silikonkabel beteckning',
        description: 'Fullständig produktbeteckning för värmebeständig kabel i varm zon.',
        defaultValue: 'Värmebeständig Silikonkabel (SiHF 3×1.5 mm², 180°C)',
        valueType: 'string',
        source: 'SEK Svensk Elstandard',
    },
    {
        id: 'electrical.standardCableType',
        category: 'electrical',
        label: 'Standardkabel beteckning',
        description: 'Produktbeteckning för standardkabel i kall zon under tröskelvärdet.',
        defaultValue: 'Standard Kabel (EKK 3×1.5 mm²)',
        valueType: 'string',
    },
    {
        id: 'electrical.hotZoneWarning',
        category: 'electrical',
        label: 'Varm zon varningstext',
        description: 'Varningstext som visas för komponenter i varm zon.',
        defaultValue: 'LIVSFARA: Standard VP-rör och PVC-kabel (ex EKK/FKX) FÅR INTE användas ovanför 500 mm i en bastu. De smälter vid ~70°C.',
        valueType: 'string',
        dangerLevel: 'critical',
    },
    {
        id: 'electrical.transformerWarning',
        category: 'electrical',
        label: 'Transformator varningstext',
        description: 'Varningstext om felplacerad transformator i bastu.',
        defaultValue: 'Placera ALDRIG transformatorn inne i bastun — om den inte sitter längst ner vid golvet (< 500 mm).',
        valueType: 'string',
        dangerLevel: 'critical',
    },
] as const satisfies readonly RuleDefinition[];
